module.exports = __webpack_public_path__ + "images/53c09ce7149a360650ecc07e09f2c8e8-LoginBrandImg.jpg";